import { NeighbouringRightsAssignment } from '../../../model/product/countries-shops';
import { WizardFeatureState } from '../../../model/product/wizard';
import { getCountries } from './state.helper';

export function neighbouringRightsCountriesToggled(state: WizardFeatureState, toggleList: string[]) {
  const countries = getCountries(state.value.neighbouringRightsSelection.countries, toggleList);

  return {
    ...state,
    value: {
      ...state.value,
      neighbouringRightsSelection: {
        ...state.value.neighbouringRightsSelection,
        countries,
      },
    },
  };
}

function upsertAssignments(
  assignments: NeighbouringRightsAssignment[],
  targetIds: readonly string[],
  patch: Partial<NeighbouringRightsAssignment>,
): NeighbouringRightsAssignment[] {
  const patched = assignments.map((a) => (targetIds.includes(a.id) ? { ...a, ...patch } : a));

  targetIds.forEach((id) => {
    if (assignments.every((a) => a.id !== id)) {
      patched.push({ id, percentage: '', startDate: undefined, endDate: undefined, ...patch });
    }
  });

  return patched;
}

// An `updatedId` of `undefined` means "every country selected for evaluation".
function withAssignments(
  state: WizardFeatureState,
  updatedId: string | undefined,
  patch: Partial<NeighbouringRightsAssignment>,
): WizardFeatureState {
  const targetIds = updatedId === undefined ? state.value.neighbouringRightsSelection.countries : [updatedId];

  return {
    ...state,
    value: {
      ...state.value,
      neighbouringRightsSelection: {
        ...state.value.neighbouringRightsSelection,
        assignments: upsertAssignments(state.value.neighbouringRightsSelection.assignments, targetIds, patch),
      },
    },
  };
}

export function neighbouringRightsPercentagesUpdated(
  state: WizardFeatureState,
  newPercentage: string,
  updatedId?: string,
) {
  return withAssignments(state, updatedId, { percentage: newPercentage });
}

export function neighbouringRightsStartDateUpdated(
  state: WizardFeatureState,
  newDate: Date | undefined,
  updatedId?: string,
) {
  return withAssignments(state, updatedId, { startDate: newDate });
}

export function neighbouringRightsEndDateUpdated(state: WizardFeatureState, newDate: Date | undefined, id?: string) {
  return withAssignments(state, id, { endDate: newDate });
}
